import { createFeatureSelector, createSelector } from '@ngrx/store';
import { XidroState } from '../_reducers/xidroDevices';

export const selectXidroState = createFeatureSelector<XidroState>('xidroDevices');

export const selectPumpSystems = createSelector(
  selectXidroState,
  (state) => state?.pumpSystems || []
);

export const selectPressureMeters = createSelector(
  selectXidroState,
  (state) => state?.pressureMeters || []
);

export const selectValves = createSelector(selectXidroState, (state) => state?.valves || []);

export const selectFlowMeters = createSelector(
  selectXidroState,
  (state) => state?.flowMeters || []
);

export const selectXidroLoading = createSelector(
  selectXidroState,
  (state) => state?.loading ?? false
);

export const selectXidroLoaded = createSelector(
  selectXidroState,
  (state) => state?.loaded ?? false
);

export const selectXidroError = createSelector(selectXidroState, (state) => state?.error || null);
